import { baseUrl } from "../../common/config";
import { http } from "../../common/helpers/http";

export const getTodosService = (params) =>
  http.get(`${baseUrl}/api/financial-wellness/todos`, {
    params,
  });

export const getTodosServiceStatus = (params) =>
  http.get(`${baseUrl}/api/financial-wellness/todos/status`, {
    params,
  });

export const getParticipantTODOService = ({ id, ...params }) =>
  http.get(`${baseUrl}/api/todos/${id}`, {
    params: {
      ...params,
      Completed: false,
    },
  });

export const getParticipantCompletedTODOService = ({ id, ...params }) =>
  http.get(`${baseUrl}/api/todos/${id}`, {
    params: {
      ...params,
      Completed: true,
    },
  });

export const getParticipantTodo = (todoId) =>
  http.get(`${baseUrl}/api/financial-wellness/todos/${todoId}`);

export const saveParticipantTodo = (data) =>
  http.post(`${baseUrl}/api/financial-wellness/todos/`, data);

export const updateParticipantTodo = (data) =>
  http.put(`${baseUrl}/api/financial-wellness/todos/`, data);

export const deleteParticipantTodoService = (todoId) =>
  http.delete(`${baseUrl}/api/financial-wellness/todos/${todoId}`);

export const updateStatusTodo = (todoId, completed) =>
  http.patch(
    `${baseUrl}/api/financial-wellness/todos/${todoId}/status?completed=${completed.toString()}`
  );

export const getTodoContent = (contentIds) =>
  http.post(`${baseUrl}/api/contents/list`, contentIds);

export const retakeAssessment = () =>
  http.post(`${baseUrl}/api/assessments/retake-participant`);

export const getLatestFocusAreas = () =>
  http.get(`${baseUrl}/api/assessments/assessment-template-by-id`);
